import { useMemo, useState } from "react";
import { Avatar, Dropdown, Layout, Menu } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "Store/hooks";
import { selectActiveKey } from "Layout/redux/selectors";
import LicenseLogo from "Assets/images/LicenseLogo.png";
import CollapseIcon from "Assets/svgs/Collapse.svg";
import { ReactComponent as SettingsIcon } from "Assets/svgs/Settings.svg";
import LocalStorageUtility from "Utilities/localstorage";
import "./sideNav.index.css";
import { getNavItems } from "./navItems";

const { Sider } = Layout;

const SideNav = () => {
  const navigate = useNavigate();
  const activeKey = useAppSelector(selectActiveKey);
  const [collapsed, setCollapsed] = useState(false);

  const authInfo = LocalStorageUtility.getUserInfoAndToken();
  const firstName = authInfo?.user?.firstName;
  const userName = authInfo?.user?.userName;

  const displayName = useMemo(() => {
    if (firstName && firstName !== "null") return firstName;
    if (userName && userName !== "null") return userName;
    return "";
  }, [firstName, userName]);

  const handleLogout = () => {
    LocalStorageUtility.deleteUserInfoAndToken();
    window.location.href = "/";
  };

  const menu = (
    <Menu>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const navItems = getNavItems(navigate);

  return (
    <Sider
      width={250}
      style={{ backgroundColor: "#fff" }}
      breakpoint="lg"
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      trigger={null}
    >
      {collapsed ? (
        <div className="demo-logo-vertical-collapsed">
          <img alt="Logo" src={LicenseLogo} />
        </div>
      ) : (
        <div className="demo-logo-vertical">
          <img alt="Logo" src={LicenseLogo} />
          <div>
            <span className="license-heading">Management </span>
            <span className="manager-heading">Portal</span>
          </div>
          <div className="collpase-icon-div">
            <img alt="Collapse Icon" src={CollapseIcon} />
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "inherit",
          height: "calc(100vh - 78px)",
          justifyContent: "space-between",
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={activeKey}
          style={{ backgroundColor: "#fff" }}
          items={navItems}
        />

        {collapsed ? (
          <div style={{ padding: "15px", paddingBottom: "10px" }}>
            <Avatar size={40} icon={<UserOutlined />} />
          </div>
        ) : (
          <div className="side-nav-footer">
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar size={40} icon={<UserOutlined />} />
              <div className="user-name">{displayName}</div>
            </div>
            <div style={{ marginLeft: "2px", marginTop: "1px" }}>
              <Dropdown overlay={menu} trigger={["click"]}>
                <SettingsIcon className="settings-icon" height={30} />
              </Dropdown>
            </div>
          </div>
        )}
      </div>
    </Sider>
  );
};

export default SideNav;
